import type { Task as TaskType } from 'ember-concurrency';
import { Task } from 'ember-concurrency/-task-property';
export default function isTask<R, Args>(obj: unknown): obj is TaskType<R, [Args]> {
  return obj instanceof Task;
}
